import { Button } from "@/components/ui/button";
import MediaPlayer from "@/components/ui/media-player";
import { createFileRoute } from "@tanstack/react-router";
import { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import conversingTogetherIntroAudio from "@/assets/audios/Conversing-together-introduction.m4a";
import { useNavigate } from "@tanstack/react-router";
import { useAuthStore } from "@/lib/stores/authStore";
import { useConversingTogetherStore } from "@/lib/stores/conversingTogetherStore";
import { ExerciseLayout } from "@/components/ui/exercise-layout";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/conversing-together/"
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "An Exercise Through Conversing Together - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "conversingTogether.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [isPausedAudio, setIsPausedAudio] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const { hasSessions, fetchSessions } = useConversingTogetherStore();

  useEffect(() => {
    if (user) {
      fetchSessions().catch(console.error);
    }
  }, [user, fetchSessions]);

  const showArchiveButton = user && hasSessions();

  const startExercise = () => {
    setIsPausedAudio(true);
    navigate({ to: "/adults/exercises/conversing-together/exercise" });
  };

  const handleArchive = () => {
    navigate({ to: "/adults/exercises/conversing-together/archive" });
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <>
          <Button className="w-full" onClick={startExercise}>
            <FormattedMessage id="conversingTogether.intro.start.button" />
          </Button>
          {showArchiveButton && (
            <Button
              className="w-full"
              variant="secondary"
              onClick={handleArchive}
            >
              <FormattedMessage id="conversingTogether.archive.button" />
            </Button>
          )}
        </>
      }
    >
      <p className="text-small">
        <FormattedMessage id="conversingTogether.intro.description" />
      </p>
      <MediaPlayer
        src={conversingTogetherIntroAudio}
        isPaused={isPausedAudio}
      />
    </ExerciseLayout>
  );
}
